export default __webpack_public_path__ + "static/media/background.291ee263.svg";